<template>
  <div
    class="customCheck2"
    :class="{
      ['customCheck2_checked']: isChecked,
    }"
    @click.stop="handleCheck"
  >
    <div
      class="customCheck2_icon"
      :class="{ 'customCheck2_no-border': noBorder }"
      :style="{ width: size + 'px', height: size + 'px' }"
    >
      <span
        v-if="isChecked"
        class="icon icon-check"
        :style="{ 'font-size': size - 3 + 'px' }"
      />
    </div>
    <span class="customCheck2_label" @click.stop="handleCheck">
      <slot></slot>
    </span>
    <slot name="append"></slot>
  </div>
</template>

<script>
export default {
  name: 'CustomCheck2',
  props: {
    value: {
      type: Boolean,
      default: () => false,
    },
    size: {
      type: Number,
      default: 24,
    },
    color: {
      type: String,
      default: '#0075c2',
    },
    checkColor: {
      type: String,
      default: '#fff',
    },
    noBorder: {
      type: Boolean,
      default: false,
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isChecked: false,
    };
  },
  watch: {
    value(val) {
      this.isChecked = val;
    },
  },
  created() {
    this.isChecked = this.value;
  },
  methods: {
    handleCheck() {
      this.isChecked = this.isGroup ? this.value : !this.isChecked;
      this.$emit('input', this.isChecked);
    },
  },
};
</script>
<style lang="scss">
.customCheck2 {
  display: flex;
  align-items: center;
  cursor: pointer;
  &_no-border {
    border: unset !important;
  }
  &_icon {
    cursor: pointer;
    display: flex;
    width: 24px;
    height: 24px;
    border-radius: 3px;
    border: 1px solid #989898;
    margin-right: 5px;
    position: relative;
    &-check {
      position: absolute;
      top: -1px;
      left: -1px;
      display: none;
    }
  }
  &_checked {
    .customCheck2_icon {
      border: solid 1.2px #0075c2;
      .icon-check {
        color: #0075c2;
        font-weight: 900;
      }
    }
  }
  &_label {
    cursor: pointer;
    font-size: 14px;
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.5;
    letter-spacing: normal;
    text-align: left;
    color: #4b4b4b;
  }
}
</style>
